import React, { useEffect, useState } from "react";
import DatePickerInput from "../../components/global/DatePicker/DatePickerInput";
import { Controller, useForm } from "react-hook-form";
import SelectFormField from "../../components/global/SelectFormField/SelectFormField";
import DatePicker from "../../components/global/FormDatePicker/DatePicker";
import "./AppTable.css";
import Tooltip from "../../components/global/Tooltip/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { GetCurrentOrderList, GetLawyersByAssistant, lawFirmSelector } from "../../features/lawFirm/lawFirmSlice";
import { monthDigits } from "../../common/constants";
import { useTranslation } from "react-i18next";
import MultiCheckboxPopupList from "../../components/global/MultiselectCheckbox/MultiselectCheckbox";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import AcceptPickupPopup from "./AcceptPickupPopup";
import { useParams } from "react-router-dom";
import { getLawfirmForInternalUser } from "../../common/utils";

function OverviewFilter({
  loading,
  DealTypeOptions,
  LawyerOptions,
  StatusOptions,
  onFilter,
  isPickup,
  isReadyforPickup,
  selectedReadyForpickupOrders,
  firmIDAndName,
  tab,
  setSelectedRows,
  reloadTabs,
  statusFilter,
  onPageReset,
  currentPage = 0,
  pageSize = 10,
  sortColumn = null,
  sortOrder = "ascending",
  initialStatusFilter,
}) {
  const [isFilterAppliedforDealandStatus, setisFilterAppliedforDealandStatus] = useState(false);
  const [isFilterAppliedforStatus, setisFilterAppliedforStatus] = useState(false);
  const [isDateFilterApplied, setisDateFilterApplied] = useState(false);
  const [islawyerFilterApplied, setislawyerFilterApplied] = useState(false);

  const [selectedDealOptions, setSelectedDealOptions] = useState([]);
  const [selectedStatusOptions, setSelectedStatusOptions] = useState([]);
  const {
    register,
    control,
    reset,
    watch,
    setValue,
    getValues,
    trigger,
    formState: { errors },
  } = useForm({
    //resolver: yupResolver(PurchaserMortgagorTabSchema),
    defaultValues: {
      ClosingDateFilter: null,
      DealTypeFilter: "",
      LawyerFilter: "",
      StatusTypeFilter: "",
      search: "",
    },
    mode: "onBlur",
  });
  const dropdownChange = (e, name) => {
    setValue(name, e);
    trigger(name);
    getOrderOverviewFilteredData();
  };
  const { id } = useParams();
  const [AcceptPopupDailog, setAcceptPopupDailog] = useState(false);

  const handleClosingDateChange = (e, name) => {
    setValue(name, e);
    trigger(name);
    getOrderOverviewFilteredData();
  };
  const { t } = useTranslation();
  const dateValue = watch("ClosingDateFilter", null);
  const dealValue = watch("DealTypeFilter", "");
  const lawyerValue = watch("LawyerFilter", "");
  const statusValue = watch("StatusTypeFilter", "");
  const search = watch("search", "");

  const { userLogin } = useSelector(authLoginSelector);

  const { DashboardLawfirm, lawyersByAssistant } = useSelector(lawFirmSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    var deals = selectedDealOptions.join(',').toString();
    var status = selectedStatusOptions.join(',').toString();

    // Reset pagination when filters change
    if (onPageReset) {
      onPageReset();
    }

    if (isPickup) {
      onFilter({ dateValue, deals, lawyerValue, search });
    } else {
      onFilter({ dateValue, deals, lawyerValue, status, search });
    }

  }, [dateValue, selectedDealOptions.length, lawyerValue, selectedStatusOptions.length, search]);

  useEffect(() => {
    if (selectedDealOptions?.length > 0 || selectedStatusOptions?.length > 0
      //|| selectedStatusOptions?.length === 0
    )
      getOrderOverviewFilteredData();
  }, [selectedDealOptions.length, selectedStatusOptions.length]);

  useEffect(() => {
    if (lawyersByAssistant === undefined || lawyersByAssistant === null) {
      dispatch(GetLawyersByAssistant(
        userLogin?.userId,
      ))
    }
    else {
      if (lawyersByAssistant?.length === 1) {
        // setValue('LawyerFilter',lawyersByAssistant[0].userId.toString());
        setValue('LawyerFilter', [{ label: lawyersByAssistant[0].lawyerWithActive, value: lawyersByAssistant[0].userId }]);
        getOrderOverviewFilteredData();
      }
    }
  }, [lawyersByAssistant]);

  const clearFilterAndReload = () => {
    console.log("clear clicked", values);

    reset();
    console.log("values", values);
    setValue("search", "");
    console.log("new values", values);

    setSelectedDealOptions([]);
    setSelectedStatusOptions([]);
    setisFilterAppliedforDealandStatus(false);
    setisFilterAppliedforStatus(false);
    setisDateFilterApplied(false);
    console.log("new values", values);
    setValue("LawyerFilter", []);
    getOrderOverviewFilteredData(true);

  };

  const values = getValues();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  useEffect(() => {
    getOrderOverviewFilteredData();
  }, [currentLanguage])

  const getOrderOverviewFilteredData = (isclear = false) => {
    if (userLogin?.isLawyer && firmIDAndName !== null) {
      dispatch(
        GetCurrentOrderList(
          getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser),
          tab,
          getValues("ClosingDateFilter") || "",
            // ?`${getValues("ClosingDateFilter").getDate()}/${monthDigits[getValues("ClosingDateFilter").getMonth()]}/${getValues("ClosingDateFilter").getFullYear()}`
            //? currentLanguage === 'en' ?
              //`${getValues("ClosingDateFilter").getDate() < 10 ? '0' + getValues("ClosingDateFilter").getDate() : getValues("ClosingDateFilter").getDate()}/${monthDigits[getValues("ClosingDateFilter").getMonth()]}/${getValues("ClosingDateFilter").getFullYear()}`
              //: `${monthDigits[getValues("ClosingDateFilter").getMonth()]}/${getValues("ClosingDateFilter").getDate() < 10 ? '0' + getValues("ClosingDateFilter").getDate() : getValues("ClosingDateFilter").getDate()}/${getValues("ClosingDateFilter").getFullYear()}`
            //: "",
          selectedDealOptions.length > 0
            ? selectedDealOptions.length === 4 ? "All" : selectedDealOptions.join(', ').toString()
            : "All",

          getValues("LawyerFilter") !== null && getValues("LawyerFilter").length > 0 && getValues("LawyerFilter") !== undefined ? getValues("LawyerFilter").map(x => x.value).join(",") : (
            DashboardLawfirm !== undefined &&
            DashboardLawfirm !== null &&
            DashboardLawfirm?.FirmID !== undefined &&
            DashboardLawfirm?.FirmID !== ""
          ) ? "" : userLogin?.userId.toString(),
          selectedStatusOptions.length > 0
            ? selectedStatusOptions.length === 8 ? "All" : selectedStatusOptions.join(', ').toString()
            : initialStatusFilter || "",
          (id?.toString() !== "" && id?.toString() !== undefined) ? id?.toString() : (isclear ? "" : search),
          true,
          currentLanguage
        )
      );
    }
    else {
      if (firmIDAndName === null) return;
      dispatch(
        GetCurrentOrderList(
          getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser),
          tab,
          getValues("ClosingDateFilter") || "",
            // ?`${getValues("ClosingDateFilter").getDate()}/${monthDigits[getValues("ClosingDateFilter").getMonth()]}/${getValues("ClosingDateFilter").getFullYear()}`
            //? currentLanguage === 'en' ?
              //`${getValues("ClosingDateFilter").getDate() < 10 ? '0' + getValues("ClosingDateFilter").getDate() : getValues("ClosingDateFilter").getDate()}/${monthDigits[getValues("ClosingDateFilter").getMonth()]}/${getValues("ClosingDateFilter").getFullYear()}`
              //: `${monthDigits[getValues("ClosingDateFilter").getMonth()]}/${getValues("ClosingDateFilter").getDate() < 10 ? '0' + getValues("ClosingDateFilter").getDate() : getValues("ClosingDateFilter").getDate()}/${getValues("ClosingDateFilter").getFullYear()}`
            //: "",
          selectedDealOptions.length > 0
            ? selectedDealOptions.join(',').toString()
            : "All",
          getValues("LawyerFilter") !== null && getValues("LawyerFilter").length > 0 && getValues("LawyerFilter") !== undefined ? getValues("LawyerFilter").map(x => x.value).join(",") : "",
          selectedStatusOptions.length > 0
            ? selectedStatusOptions.join(',').toString()
            : initialStatusFilter || "",
          (id?.toString() !== "" && id?.toString() !== undefined) ? id?.toString() : (isclear ? "" : search),
          true,
          "",
          "",
          userLogin?.internalUser ? "" : userLogin?.userId.toString(),
          currentLanguage
        )
      );
    }
  };

  const multiSelectOnChange = (e, name) => {
    if (e && e.length > 1 && e.filter((x) => x.value === "0").length > 0) {
      const index = e.findIndex((x) => x.value === "0");
      e.splice(index, 1);
      setislawyerFilterApplied(false);
    }

    if (e?.length > 1) {
      setValue(name, e?.filter(item => item.value !== 'All'));
    }
    else {
      setValue(name, e);
    }

    if (e || e === "0") {
      trigger(name);
      if (e.length >= 1) {
        setislawyerFilterApplied(true);
      }
      else {
        setislawyerFilterApplied(false);

      }

    }

    getOrderOverviewFilteredData();

  };

  const handleDealSelect = (newSelectedOptions) => {

    setSelectedDealOptions(newSelectedOptions);
    // getOrderOverviewFilteredData();

  };

  const handleStatuSelect = (newSelectedOptions) => {
    setSelectedStatusOptions(newSelectedOptions);
    // getOrderOverviewFilteredData();

  };


  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // Trigger your search logic here
      getOrderOverviewFilteredData()
    }
  };


  return (
    <>
      <div className="flex flex-row">
        <div className="flex flex-row gap-[16px] pb-[24px] pt-[26px] w-max">
          <div className="flex" role="application">
            <div
              className={
                isReadyforPickup ? "w-[375px] mr-4" : "w-[375px]" + " h-[40px]"
              }
            >
              <div className="custom__icon-textfield relative">
                <input
                  type="text"
                  id="headerSearch"
                  className="placeholder-placeholder"
                  aria-label="Header search"
                  value={search}
                  {...register(`search`)}
                  placeholder={t("OverViewFilterSearchplaceholder")}
                  // onBlur={() =>{ 
                  //   if(search!=="")
                  //   getOrderOverviewFilteredData()}
                  // }
                  onKeyDown={handleKeyDown}
                />
                <button onClick={() => {
                  if (search !== "")
                    getOrderOverviewFilteredData()
                }}>
                  <img
                    src="../../images/search-icon.527ce689.svg"
                    className="!h-[20px] !w-[20px] absolute left-[16px] top-[10px]"
                    alt="search icon"
                  />
                </button>
              </div>
            </div>
          </div>

          {(!userLogin?.isLawyer || userLogin?.internalUser) &&
            // <div className={`select-container ${isFilterApplied ? 'filter-applied' : ''}`}>
            <SelectFormField
              options={LawyerOptions}
              dropdownChange={dropdownChange}
              control={control}
              value={lawyerValue}
              loading={loading}
              fieldName="LawyerFilter"
              ariaLabel="LawyerFilter"
              selectClassNames="custom__dropdown-wrapper h-[40px] w-[180px]"
              defaultOption={t("All")}
              placeholder={t("LawyerName")}
              isMultiSelect={true}
              multiSelectOnChange={multiSelectOnChange}
              islawyerFilterApplied={islawyerFilterApplied}
              setislawyerFilterApplied={setislawyerFilterApplied}
              isOrderStatus={true}
            />

          }
          <MultiCheckboxPopupList
            label={t("DealTypeHeader")}
            options={DealTypeOptions}
            selectedOptions={selectedDealOptions}
            onSelect={handleDealSelect}
            setSelectedOptions={setSelectedDealOptions}
            setisFilterAppliedforDealandStatus={setisFilterAppliedforDealandStatus}
            isFilterAppliedforDealandStatus={isFilterAppliedforDealandStatus}
          // register={register}
          // fieldName={`DealTypeFilter`}
          // values={values}
          // checked={values?.DealTypeFilter}
          />
          {/* <p>Selected options: {selectedOptions.join(', ')}</p> */}
          {!isReadyforPickup && (
            <div className="custom__dropdown-wrapper h-[40px] w-[180px]">
              <div className="h-[24px] w-full">
                <div className="custom__datepicker bg-white w-full size__sm">
                  <Controller
                    control={control}
                    name={`ClosingDateFilter`}
                    render={({ field, value }) => (
                      <DatePickerInput
                        field={field}
                        value={dateValue}
                        fieldName={`ClosingDateFilter`}
                        handleChange={(val) => {
                          handleClosingDateChange(val, "ClosingDateFilter");
                        }}
                        register={register}
                        trigger={trigger}
                        setisDateFilterApplied={setisDateFilterApplied}
                        isDateFilterApplied={isDateFilterApplied}
                        isOrderStatus={true}
                      />
                    )}
                  />
                </div>
              </div>
            </div>)
          }

          {!isReadyforPickup && (
            <div className="ml-14">
              <MultiCheckboxPopupList
                label={t("Status")}
                options={StatusOptions}
                // options={options}
                selectedOptions={selectedStatusOptions}
                onSelect={handleStatuSelect}
                setSelectedOptions={setSelectedStatusOptions}
                register={register}
                fieldName={`StatusTypeFilter`}
                values={values}
                statusFilter={statusFilter}
                setisFilterAppliedforStatus={setisFilterAppliedforStatus}
                isFilterAppliedforStatus={isFilterAppliedforStatus}
              />
            </div>
          )}

          <div className={isReadyforPickup ? "pt-2" : "" + " w-max mt-2"}>
            <button
              type="reset"
              onClick={() => {
                clearFilterAndReload();
              }}
              className={
                "font-[600] font-open-sans leading-[19.07px] px-[14px] text-[#526D7D] text-[14px]"
              }
            >
              {t("ClearFilter")}
            </button>
          </div>
        </div>

        {isReadyforPickup && (
          <div className="w-max flex flex-row ml-auto pb-6 pt-6">
            <button
              id="confirm-pickup"
              className={
                "!hover:bg-[#FAE094] border-box-stroke btn__secondary font-[600] font-open-sans leading-[19.07px] px-[14px] text-[16px] text-box-stroke w-auto h-full w-max " +
                (selectedReadyForpickupOrders?.length > 0
                  ? "btn__secondary-active"
                  : "")
              }
              disabled={selectedReadyForpickupOrders?.length > 0 ? "" : "true"}
              onClick={() => setAcceptPopupDailog(true)}
            >
              <div className="flex">
                {t("AcceptPickup")}
                <Tooltip text={t("AcceptpickupTooltip")} />
              </div>
            </button>
            {AcceptPopupDailog && <AcceptPickupPopup setAcceptPopupDailog={setAcceptPopupDailog} selectedReadyForpickupOrders={selectedReadyForpickupOrders} setSelectedRows={setSelectedRows} reloadTabs={reloadTabs} />}
          </div>
        )}
      </div>
    </>
  );
}

export default React.memo(OverviewFilter);
